import {connect} from 'react-redux';
import {List} from 'immutable';

import {
  loadRelationship,
  updateRelationship,
  createRelationship,
  deleteRelationship,
  relationshipFormDestroy
} from '../../../../../state/modules/relationships/actions';
import {sendMessage} from '../../../../../state/actions';
import RelationshipForm from '../components/RelationshipForm';

const inputs = List([
  'name',
  'order',
  'status'
]);

const mapStateToProps = (state, ownProps) => {

  const data = {}, errors = {};
  for (const val of inputs.values()) {
    data[val] = state.entities.getIn(['relationships', ownProps.id, val], '');
    if (state.relationships.getIn(['form', 'errors', val])) {
      errors[val] = state.relationships.getIn(['form', 'errors', val]);
    }
  }

  // change select number values to strings to work with ant design select inputs
  Object.keys(data).forEach(x => {
    if (['status'].includes(x)) {
      data[x] = data[x].toString();
    }
  });

  return {
    isLoading: state.relationships.get('isLoading'),
    isSubmitting: state.relationships.getIn(['form', 'isSubmitting']),
    success: state.relationships.getIn(['form', 'success']),
    created_id: state.relationships.getIn(['form', 'created_id']),
    data: data,
    errors: errors,
    createdAt: state.entities.getIn(['relationships', ownProps.id, 'created_at'], null),
    updatedAt: state.entities.getIn(['relationships', ownProps.id, 'updated_at'], null),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    load: (id, cb) => {
      dispatch(loadRelationship(id, cb));
    },
    update: (id, data, cb) => {
      dispatch(updateRelationship(id, data, cb));
    },
    create: (data, cb) => {
      dispatch(createRelationship(data, cb));
    },
    delete: (id, cb) => {
      dispatch(deleteRelationship(id, cb))
    },
    destroyForm: (formState) => {
      dispatch(relationshipFormDestroy(formState));
    },
    sendMessage: (level, title, body, expires) => {
      dispatch(sendMessage(level, title, body, expires));
    },
  }
}

const RelationshipFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(RelationshipForm);

export default RelationshipFormContainer;
